export default {
    dealership: 'Au concessionnaire',
    customer: 'Chez le client',
    custom: 'Autre adresse',
};
